import { useState } from "react";
import { Box, InputAdornment, Button, TextField, useTheme } from "@mui/material";
import { CloseIcon, SendMessageIcon, SmileIcon } from "~components/Icons";
import { useSocketContext } from "~contexts/Socket";
import { useStreamContext } from "~contexts/Stream";
import { getRoomsWithOperatorsLastMessage } from "~helpers/chat";
import type { IMessage } from "~contexts/Socket/interfaces";

interface IProps {
  replyingTo: IMessage | null;
  setReplyingTo: (value: IMessage | null) => void;
}

interface IResponse {
  message: IMessage;
  ok: boolean;
}

const InputChat = ({ replyingTo, setReplyingTo }: IProps) => {
  const theme = useTheme();
  const { currentStream } = useStreamContext();
  const [replyMessage, setReplyMessage] = useState<string>("");
  const { socket, messages, setMessages, setMessagesRooms } = useSocketContext();

  const replyToUser = () => {
    if (socket && !!replyMessage.length && currentStream) {
      socket.emit(
        "replyChatToUser",
        {
          privateRoom: replyingTo?.privateRoom,
          text: replyMessage,
          email: currentStream.brand,
          replyingTo: replyingTo?.id,
        },
        (response: IResponse) => {
          if (response.ok) {
            setMessages([...messages, response.message]);
            setMessagesRooms((currState: IMessage[]) =>
              getRoomsWithOperatorsLastMessage(currState, response.message)
            );
            return;
          }
        }
      );

      setReplyingTo(null);
      setReplyMessage("");
    }
  };

  return (
    <Box style={{ marginTop: "24px", height: "60px", display: "flex" }}>
      <TextField
        autoFocus
        fullWidth
        hiddenLabel
        variant="outlined"
        value={replyMessage}
        onKeyPress={(e) => e.key === "Enter" && replyToUser()}
        placeholder="escreva sua mensagem aqui..."
        onChange={(e) => setReplyMessage(e.target.value)}
        inputProps={{ style: { paddingLeft: "10px" } }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="end">
              <SmileIcon />
            </InputAdornment>
          ),
        }}
        sx={{
          "& input::placeholder": {
            color: theme.palette.grey[800],
            fontSize: "16px",
          },
        }}
      />
      <Button
        disableRipple
        disableFocusRipple
        variant="roundButtonChat"
        onClick={() => (!!replyMessage.length ? replyToUser() : setReplyingTo(null))}
      >
        {!!replyMessage.length ? <SendMessageIcon /> : <CloseIcon />}
      </Button>
    </Box>
  );
};

export default InputChat;
